module.exports = __webpack_public_path__ + "media/components/src/assets/images/blogs/2-281543d2376bd7414ab341dfec792ae5.jpg";